export const async_amazon_prices = {
  asyncType: 'amazon-prices',
  hostedScraperType:  'async_amazon_prices',
  publicHostedScraperAPIType:  'amazon_prices',
  inputKey: 'asin_list',
  apiQueryParameter: 'asins',
  inputsKey: 'asin_lists',
  // Comma separated list of JSONs. 8 values max.
  inputJsonSchema: { type: 'string', pattern: '^[a-zA-Z0-9]{10}(,[a-zA-Z0-9]{10}){0,7}$' },
  asyncEndpoint: '/structured/amazon/prices',
  apiEndpoint: '/structured/amazon/prices',
  apiCostEndpoint: '/account/amazonpricescost',
  propertiesJsonSchemaPart: {
    output_format: { type: 'string', enum: [ 'csv', 'json' ] },
    tld: { type: 'string' },
    country_code: { type: 'string' },
  }
};
